<template>
  <div class="verify" :class="{'verify--verifying': isVerifying}">
    <i class="el-icon-loading"></i>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: "Verify",
    computed: {
      ...mapState('login', ['isVerifying'])
    }
  }
</script>

<style lang="scss">
  .verify {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: #776b6b;
    transform: translate(0, -100%);
    -webkit-transform: translate(0, -100%);
    -moz-transform: translate(0, -100%);
    -ms-transform: translate(0, -100%);
    -o-transform: translate(0, -100%);
    transition: transform 0.3s ease-out 0.5s;
    -webkit-transition: transform 0.3s ease-out 0.5s;
    -moz-transition: transform 0.3s ease-out 0.5s;
    -o-transition: transform 0.3s ease-out 0.5s;

    &--verifying {
      transform: translate(0, 0);
      -webkit-transform: translate(0, 0);
      -moz-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
    }

    i {
      font-size: 50px;
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -25px;
      margin-left: -25px;
    }
  }
</style>